import {
    DATES_LIST_REQUEST,
    DATES_LIST_SUCCESS,
    DATES_LIST_FAIL
} from "../constants/application";

const initialState = {
  list: [],
  error: null,
  loading: false
};

export default function datesReducer(state = initialState, action) {
  switch (action.type) {
    case DATES_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case DATES_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload,
        error: null
      };
    case DATES_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}
